import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrain = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 31V27",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 19H14C15.5913 19 17.1174 19.6321 18.2426 20.7574C19.3679 21.8826 20 23.4087 20 25V27H19C17.4087 27 15.8826 26.3679 14.7574 25.2426C13.6321 24.1174 13 22.5913 13 21V19Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 27H20V25C20 23.4087 20.6321 21.8826 21.7574 20.7574C22.8826 19.6321 24.4087 19 26 19H27V21C27 22.5913 26.3679 24.1174 25.2426 25.2426C24.1174 26.3679 22.5913 27 21 27V27Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 14C18.0445 13.2324 18.2447 12.482 18.5886 11.7943C18.9324 11.1066 19.4126 10.4961 20 10C20.5874 10.4961 21.0676 11.1066 21.4114 11.7943C21.7553 12.482 21.9555 13.2324 22 14C21.9555 14.7676 21.7553 15.518 21.4114 16.2057C21.0676 16.8934 20.5874 17.5039 20 18C19.4126 17.5039 18.9324 16.8934 18.5886 16.2057C18.2447 15.518 18.0445 14.7676 18 14V14Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgGrain);
export default ForwardRef;
